import allPrompts from "../data/prompts.json";
import { Prompt, PromptCategory } from "../types/frontend";

/**
 * Returns the starter prompts to display, always including the 'about_chatbot' prompt and 3 random others.
 * This is a pure function and does not use React state or effects.
 */
export function getStarterPrompts(): Prompt[] {
  // Always include the "What are you useful for?" prompt
  const aboutPrompt = allPrompts.find(
    (p) => p.category === PromptCategory.AboutChatbot
  );

  // Filter out the about prompt and get other prompts
  const otherPrompts = allPrompts.filter(
    (p) => p.category !== PromptCategory.AboutChatbot
  );

  // Randomly select 3 prompts from the other prompts
  const randomPrompts = [...otherPrompts]
    .sort(() => 0.5 - Math.random())
    .slice(0, 3);

  // Combine the about prompt with random prompts
  const selectedPrompts = aboutPrompt
    ? [aboutPrompt, ...randomPrompts]
    : randomPrompts;

  return selectedPrompts as Prompt[];
}

/**
 * Returns true if the given string matches the message or label of any starter prompt.
 */
export function isStarterPrompt(text: string): boolean {
  return allPrompts.some((p) => p.message === text || p.label === text);
}

/**
 * Returns true if the given string matches the message or label of any starter prompt in the given category.
 */
export function isStarterPromptInCategory(
  text: string,
  category: PromptCategory
): boolean {
  return allPrompts.some(
    (p) => (p.message === text || p.label === text) && p.category === category
  );
}

/**
 * Returns all starter prompts in a given category.
 */
export function getStarterPromptsByCategory(
  category: PromptCategory
): Prompt[] {
  return allPrompts.filter((p) => p.category === category) as Prompt[];
}
